import React, { useEffect, useState } from "react";
import { Star, Save } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

export function ReviewBonusSettings() {
  const [cfg, setCfg] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get("/admin/settings/review-bonus").then((r) => setCfg(r.data)).catch(console.error); }, []);
  if (!cfg) return null;
  const upd = (k) => (e) => setCfg((c) => ({ ...c, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value }));
  const save = async () => {
    try {
      const { data } = await api.put("/admin/settings/review-bonus", { enabled: !!cfg.enabled, discount_type: cfg.discount_type, discount_value: Number(cfg.discount_value), validity_days: Number(cfg.validity_days) });
      setCfg(data); toast.success("Bonus avis enregistré ✓");
    } catch (e) { toast.error(e?.response?.data?.detail?.[0]?.msg || e?.response?.data?.detail || "Erreur"); }
  };
  const inp = "bg-ink border border-zinc-700 px-3 py-2 text-white text-sm w-full focus:border-neon-green outline-none";
  const s = cfg.stats || {};
  return (
    <div data-testid="review-bonus-settings" className="border border-zinc-800 bg-ink-surface mb-6">
      <button type="button" data-testid="review-bonus-toggle" onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between px-4 py-3 text-left gap-3">
        <span className="font-anton uppercase text-white flex items-center gap-2"><Star className="h-4 w-4 text-neon-green" /> Bonus fidélité après avis</span>
        <span data-testid="review-bonus-summary" className="text-zinc-500 text-xs text-right">{cfg.enabled ? `${cfg.label} offert · ${s.issued || 0} codes émis · ${s.used || 0} utilisés` : "Désactivé"} {open ? "▲" : "▼"}</span>
      </button>
      {open && (
        <div className="px-4 pb-4 space-y-3">
          <p className="text-zinc-400 text-xs">Après la livraison, le livreur envoie une demande d'avis WhatsApp en 1 clic. Dès que le client note sa commande, il reçoit un <span className="text-white">code promo personnel à usage unique</span> (lié à son numéro), absorbé par la maison mère et valable dans toutes les boutiques.</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <label className="min-h-[44px] flex items-center gap-3 text-sm text-zinc-300 border border-zinc-800 px-3">
              <input data-testid="rb-enabled" type="checkbox" checked={!!cfg.enabled} onChange={upd("enabled")} className="accent-neon-green h-4 w-4" /> Bonus activé
            </label>
            <div className="flex gap-2">
              <select data-testid="rb-type" value={cfg.discount_type} onChange={upd("discount_type")} className={inp}>
                <option value="amount">Montant €</option>
                <option value="percent">Pourcentage %</option>
              </select>
              <input data-testid="rb-value" type="number" step="0.5" min="0" max="100" value={cfg.discount_value} onChange={upd("discount_value")} className={inp} />
            </div>
            <label className="text-xs text-zinc-400">Validité du code (jours)<input data-testid="rb-days" type="number" min="1" max="365" value={cfg.validity_days} onChange={upd("validity_days")} className={inp} /></label>
            <div className="text-xs text-zinc-500 self-end pb-2" data-testid="review-bonus-stats">Avis sur commande : <span className="text-white">{s.order_reviews || 0}</span> · Codes émis : <span className="text-white">{s.issued || 0}</span> · Utilisés : <span className="text-neon-green">{s.used || 0}</span></div>
          </div>
          <button data-testid="rb-save" onClick={save} className="w-full inline-flex items-center justify-center gap-2 bg-neon-green text-black font-anton uppercase px-4 py-2.5"><Save className="h-4 w-4" /> Enregistrer</button>
        </div>
      )}
    </div>
  );
}
